<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import ClientPortalsAPI from 'dashboard/api/clientPortals';
import Modal from 'dashboard/components/Modal.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  portal: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['close', 'save']);
const { t } = useI18n();

const form = ref({
  name: '',
  slug: '',
});

const loading = ref(false);
const isEdit = computed(() => !!props.portal);

onMounted(() => {
  if (props.portal) {
    form.value = {
      name: props.portal.name,
      slug: props.portal.slug,
    };
  }
});

const generateSlug = () => {
  if (!isEdit.value && form.value.name) {
    form.value.slug = form.value.name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
};

const handleSubmit = async () => {
  loading.value = true;
  try {
    if (isEdit.value) {
      await ClientPortalsAPI.update(props.portal.id, {
        client_portal: form.value,
      });
      useAlert('Portal updated successfully');
    } else {
      await ClientPortalsAPI.create({ client_portal: form.value });
      useAlert('Portal created successfully');
    }
    emit('save');
  } catch (error) {
    useAlert(error.response?.data?.message || 'An error occurred');
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <Modal
    :title="isEdit ? 'Modifier le portail' : 'Nouveau portail'"
    :show="true"
    @close="emit('close')"
  >
    <form class="space-y-4" @submit.prevent="handleSubmit">
      <Input
        v-model="form.name"
        label="Nom du portail"
        placeholder="Ex: Dashboard Client A"
        required
        @input="generateSlug"
      />

      <Input
        v-model="form.slug"
        label="URL Slug"
        placeholder="ex: dashboard-client-a"
        required
        :help-text="'L\'URL sera /client_portals/' + (form.slug || '...')"
      />

      <div class="flex justify-end gap-2 mt-6">
        <Button
          variant="outline"
          color="slate"
          label="Annuler"
          @click="emit('close')"
        />
        <Button
          type="submit"
          :label="isEdit ? 'Enregistrer' : 'Créer'"
          :loading="loading"
        />
      </div>
    </form>
  </Modal>
</template>
